<template>
  <div>
    <div v-if="!processing">
      <div
        :style="template.secondaryTheme ? 'color: white; font-size: 0.85rem;' : ''"
        class="col form-group mt-3"
      >
        <label class="mb-1">{{ $t('country.label') }}</label>
      </div>

      <div class="col form-group mt-3">
        <select
          class="w-100 c-input"
          id="country-select"
          v-model="countryName"
          @change="selectCountry"
        >
          <option
            class="text-black"
            v-for="(i, index) in countries"
            :value="i.country_Name_En"
            :key="index"
          >
            {{ i.country_Name_En }}
          </option>
        </select>
      </div>
    </div>

    <div v-else class="text-center">
      <LoadingRing />

      <!-- <p :style="template.secondaryTheme ? 'color: white; font-size: 0.85rem;' : ''">
        Aguarde, estamos buscando a lista de países.
      </p> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import { loginFB } from '../../services/ServFB.js'

import { getSSORedirectUrl } from '@/helpers/ssoHelper'

const lFB = new loginFB()

export default {
  name: 'Country',
  props: {
    validate: Boolean,
  },
  data: () => ({
    obj: {},
    key: 0,
    countryName: '',
    selectedCountry: null,
    processing: true,
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template', 'countries']),
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    this.clearRegistrationErrors()

    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    if (this.obj.cpf) {
      this.$emit('next')
    } else {
      lFB
        .GetCountries()
        .then(data => {
          this.setCountries(data)
          this.processing = false
        })
        .catch(err => {
          alert(this.$t('country.loadError') + ' ' + err)
          this.$router.push(this.goToHomePage)
        })
    }
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    ...mapActions(['setCountries', 'setSelectedCountryId']),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.$t('common.attention'),
        variant: variant,
        solid: true,
      })
    },
    selectCountry() {
      const country = this.countries.find(c => c.country_Name_En === this.countryName)

      if (country) {
        this.selectedCountry = country
        this.setSelectedCountryId(country.id)
      } else {
        this.selectedCountry = null
      }
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      const found = this.countries.find(
        el =>
          el.country_Name_En.toLowerCase() === this.selectedCountry.country_Name_En.toLowerCase(),
      )

      if (this.selectedCountry.country_Name_En.toLowerCase() === 'brazil') {
        this.$emit('previous')
      } else {
        if (!found) {
          hasErrors = true

          this.selectedCountry = ''

          const warningMsg = this.$t('country.required')

          this.addRegistrationError({ msg: warningMsg })

          this.toastMessage = warningMsg

          this.makeToast('warning')
        } else {
          this.obj.country = found.id
        }

        if (!hasErrors) {
          this.$store.commit('updateRegistrationObject', this.obj)
          this.$emit('next')
        }
      }
    },
  },
}
</script>

<style scoped>
.c-option {
  background-color: none !important;
  color: white;
}

.c-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 0.01px; /* Fix for Firefox */
  text-overflow: ''; /* Fix for IE */
}
.form-check-input {
  appearance: none;
  border-radius: 100%;
  height: 16px;
  width: 16px;
  border: 1px solid #fff;
  background-color: transparent;
  transition: all;
  transition-duration: 200ms;
  margin-top: 0px;
  margin-right: 8px;
  align-self: initial;
  float: left;
  cursor: pointer;
}

.left-align {
  text-align: left;
}

.form-check-input:checked {
  background-color: var(--primary-color);
}

.form-check-input:focus {
  outline: none;
}

.form-radio label {
  margin-bottom: 0.5;
}
</style>
